import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FormAsyncSelectField } from '../../../../common/components/formFields';
import { searchAdminManagers } from './AccountManagerActions';

function AccountManagerSelectField(props) {
  const dispatch = useDispatch();

  const loadOptions = (inputValue, callback) => {
    dispatch(
      searchAdminManagers(inputValue, (response) => {
        const list = response?.content || response?.data?.content || [];
        const options = (Array.isArray(list) ? list : []).map((it) => ({
          value: it?.id || it?.memberId,
          label: (
            it?.fullName || [it?.firstName, it?.lastName].filter(Boolean).join(' ')
          ).trim(),
        }));
        callback(options);
      }),
    );
    return true;
  };

  return (
    <FormAsyncSelectField
      {...props}
      loadOptions={loadOptions}
      loadRightAway={props?.loadRightAway}
      defaultOptions
    />
  );
}

AccountManagerSelectField.defaultProps = {
  loadRightAway: true,
};

AccountManagerSelectField.propTypes = {
  loadRightAway: PropTypes.bool,
};

export default AccountManagerSelectField;
